import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomerRevealApiQuota } from 'features/customers/hooks/useCustomerRevealApiQuota'

import { hasRevealConfig, type RevealQuotaDimension, revealCredits, revealLimit } from '@albacross/types'

import QuotaUsage from 'components/_base/QuotaUsage'

import NotEnabled from './NotEnabled'
import UsageUnavailable from './UsageUnavailable'

const USAGE_KEY = {
  requests: 'requestsQuotaUsage',
  identified: 'identifiedQuotaUsage',
  uniqueIdentifiedIps: 'uniqueIdentifiedIpsQuotaUsage',
} as const

type CustomerRevealApiQuotaUsageProps = {
  type: RevealQuotaDimension
}

const CustomerRevealApiQuotaUsage = ({ type }: CustomerRevealApiQuotaUsageProps) => {
  const { data, isLoading, isError } = useCustomerRevealApiQuota()

  if (isError) return <UsageUnavailable />
  if (isLoading) return <Skeleton variant="text" width={85} />
  if (!hasRevealConfig(data)) return <NotEnabled />

  const usage = data[USAGE_KEY[type]] ?? 0
  const extra = revealCredits(data, type)

  return <QuotaUsage extra={extra} quota={revealLimit(data, type)} usage={usage} />
}

export default CustomerRevealApiQuotaUsage
